var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { swapInPlace } from './_swapInPlace';
export var quickSelect = function (data, index, compareFn) {
    return index < 0 || index >= data.length
        ?
            undefined
        : quickSelectImplementation(__spreadArray([], data, true), 0, data.length - 1, index, compareFn);
};
function quickSelectImplementation(data, left, right, index, compareFn) {
    if (left === right) {
        return data[left];
    }
    var pivotIndex = partition(data, left, right, compareFn);
    return index === pivotIndex
        ?
            data[index]
        : quickSelectImplementation(data, index < pivotIndex ? left : pivotIndex + 1, index < pivotIndex ? pivotIndex - 1 : right, index, compareFn);
}
function partition(data, left, right, compareFn) {
    var pivot = data[right];
    var i = left;
    for (var j = left; j < right; j++) {
        if (compareFn(data[j], pivot) < 0) {
            swapInPlace(data, i, j);
            i++;
        }
    }
    swapInPlace(data, i, right);
    return i;
}
